module.exports = __webpack_public_path__ + "static/media/introduce-top.78606528.JPG";